import React from 'react';

type Props = {
  className: string;
};

export const InnerShadow = ({ className }: Props) => {
  return <div className={'card-inner-shd ' + className}></div>;
};
